// extracted by mini-css-extract-plugin
export var ctaCard = "TutorialCtaCard-module--cta-card--59ab9";